import { Shop, ActionsType } from '@card/types';
import { createAction, createErrorAction } from './actionCreator';

export enum ShopsActionType {
  Fetch = 'shops/fetch',
  FetchSuccess = 'shops/fetch_success',
  FetchError = 'shops/fetch_error',
  ModifyShopName = 'shops/modify_name',
  DeleteShop = 'shops/delete',
  DestroyShop = 'shops/destroy',
  ActionSetShopName = 'shops/set_name',
  SaveShops = 'shops/save',
  AsyncSetShopNameStatus = 'shops/async_set_name_status',
  UpdateShopError = 'shops/update_error'
}

type ModifyShopNamePayloadType = {
  id: string;
  name: string;
};

type SetShopNamePayloadType = {
  position: number;
  name: string;
};

type ErrorParamsType = {
  error: Error;
  id: string;
};

type DestroyShopPayloadType = {
  id: string;
  position: number;
};

const ShopActions = {
  fetch: () => createAction(ShopsActionType.Fetch),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchSuccess: (shops: Shop[]) => createAction(ShopsActionType.FetchSuccess, shops),
  fetchError: (error: Error) => createErrorAction(ShopsActionType.FetchError, error),
  modifyShopName: (params: ModifyShopNamePayloadType) =>
    createAction(ShopsActionType.ModifyShopName, params),
  setShopName: (params: SetShopNamePayloadType) =>
    createAction(ShopsActionType.ActionSetShopName, params),
  deleteShop: (position: number) => createAction(ShopsActionType.DeleteShop, position),
  destroyShop: (params: DestroyShopPayloadType) =>
    createAction(ShopsActionType.DestroyShop, params),
  saveShopsMethods: (shops: Shop[]) => createAction(ShopsActionType.SaveShops, shops),
  asyncSetShopNameStatus: (id: string) => createAction(ShopsActionType.AsyncSetShopNameStatus, id),
  updateShopError: (error: ErrorParamsType) => createAction(ShopsActionType.UpdateShopError, error)
};

export type ShopAction = ActionsType<typeof ShopActions>;
export default ShopActions;
